import styles from "./Button.module.scss"
import classNames from "classnames"
import Image from "next/image"
import { JSX, MouseEvent } from "react"

interface ButtonConfig {
  children?
  size?: "small" | "medium" | "tab"
  onClick?: (event: MouseEvent) => void
  raised?: boolean
  color?: "success" | "danger" | "warning"
  uppercase?: boolean
  style?
  variant?: "primary" | "text" | "outlined" | "contained" | "underlined" | "CTA" | "secondaryCTA" | "icon" | "FAB"
  startIcon?: string | JSX.Element
  className?
  disabled?
  hug?: boolean
  type?: "button" | "submit" | "reset"

  [key: string]: unknown
}

const Button = ({
  onClick,
  variant = "contained",
  size = "medium",
  uppercase = false,
  className,
  startIcon,
  raised = false,
  children,
  disabled,
  color = "success",
  style,
  type,
  hug = false,
  ...other
}: ButtonConfig) => {
  return (
    <>
      <button
        type={type}
        disabled={disabled}
        onClick={onClick}
        style={style}
        className={classNames(className, styles.btn, styles[size], styles[color], {
          [styles.specialSmallSidePadding]:
            size == "small" && !!startIcon && (variant == "outlined" || variant == "contained"),
          [styles.uppercase]: uppercase,
          [styles.raised]: raised,
          [styles.contained]: variant == "contained",
          [styles.textNoHover]: variant == "text" && !onClick,
          [styles.underlined]: variant == "underlined",
          [styles.outlined]: variant == "outlined",
          [styles.text]: variant == "text" && !!onClick,
          [styles.primary]: variant == "primary",
          [styles.CTA]: variant == "CTA",
          [styles.secondaryCTA]: variant == "secondaryCTA",
          [styles.icon]: variant == "icon",
          [styles.FAB]: variant == "FAB",
          [styles.hug]: hug,
        })}
        {...other}
      >
        {!!startIcon && (
          <span className={styles.startIcon}>
            {typeof startIcon !== "string" ? (
              startIcon
            ) : (
              <Image
                width={12}
                height={12}
                src={startIcon}
                alt={"start-icon"}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            )}
          </span>
        )}
        {children}
      </button>
    </>
  )
}
export default Button
